import React, { useEffect, useState } from 'react';
import '../css/CourseDetail.css';
import Header from '../component/layout/Header';
import Footer from '../component/layout/Footer';
import automotiveImg from '../assets/images/automobile.webp';
import CourseDetailPageComponent from '../component/CourseDetatilComponent/CourseDetailPageComponent';
import HomeBackground from '../assets/images/HomeBackground.png';
import { useParams } from 'react-router-dom';
import Loader from '../component/Loader/Loader';
import { fetchAllModuleOfCourse, fetchSingleCourse } from '../helper/course_helper';
import { toast } from 'react-toastify';
import Layout from '../component/layout/Layout';
import { useCart } from '../context/CardContext';
import { generatePresignedUrlForAccess } from '../helper/content_helper';


const CourseDetails = () => {
    const [loader, setLoader] = useState(false);
    const [course, setCourse] = useState({});
    const [modules, setModules] = useState([]);
    const params = useParams();

    const fetchCourse = async () => {
        try {
            setLoader(true);
            const data = await fetchSingleCourse(params.id);

            if (data?.success) {
                updateCourseMedia(data?.result?.[0]);
                fetchModules(data?.result?.[0]);
            } else {
                toast.error(data?.message);
            }

        } catch (error) {
            toast.error(error?.response?.data?.message || "Something went wrong");
        } finally {
            setLoader(false);
        }
    };

    const updateCourseMedia = async (course) => {
        if (course?.thumbnailName || course?.introVideoName) {
            let thumbnailUrl = null;
            let introVideoUrl = null;

            if (course?.thumbnailName) {
                let name = course.thumbnailName;
                let type = "image";
                const response = await generatePresignedUrlForAccess({ name, type });

                if (response.success) {
                    thumbnailUrl = response.presignedUrl;
                } else {
                    console.error('Error generating pre-signed URL for thumbnail', course.thumbnailName);
                }
            }

            if (course?.introVideo) {
                let name = course.introVideo;
                let type = "Video";
                const response = await generatePresignedUrlForAccess({ name, type });

                if (response.success) {
                    introVideoUrl = response.presignedUrl;
                } else {
                    console.error('Error generating pre-signed URL for intro video', course.introVideoName);
                }
            }

            const updatedCourse = {
                ...course,
                thumbnailUrl,
                introVideoUrl,
            };

            setCourse(updatedCourse);
        } else {
            console.log('No thumbnail or intro video name found in course:', course);
            setCourse(course);
        }
    };

    const fetchModules = async (c) => {
        try {
            setLoader(true);
            let courseDto = c;
            const data = await fetchAllModuleOfCourse(courseDto);
            if (data?.success) {
                setModules(data?.result);
            }
        } catch (error) {
            toast.error(error?.response?.data?.message);
        } finally {
            setLoader(false);
        }
    }

    useEffect(() => {
        window.scrollTo(0, 0);
        fetchCourse();
    }, [params.id]);

    return (
        <>
            {loader && <Loader />}

            <Layout tab={2}>
                <div style={styles.pageContainer}>
                    <CourseDetailPageComponent course={course} modules={modules} />
                </div>
            </Layout>
        </>
    );
};

const styles = {
    pageContainer: {
        backgroundColor: "#F9F9F9",
        minHeight: "100vh"
    },
};

export default CourseDetails;


/* Add this CSS to your global stylesheet for responsive course details */
/*
.course-detail-container {
    max-width: 1400px;
    margin: 0 auto;
    padding: 0 20px;
}

@media (max-width: 768px) {
    .course-detail-container {
        padding: 0 16px;
    }
}

@media (max-width: 480px) {
    .course-detail-container {
        padding: 0 12px;
    }
}
*/